import { useContext } from 'react';
import { MapSearchBoxContext, MapSearchBoxContextData } from './MapSearchBoxContext';

export const useMapBoxSearchContext = (): MapSearchBoxContextData => {
  const context = useContext(MapSearchBoxContext);
  if (!context) {
    throw new Error('Unable to find MapSearchBoxContext');
  }

  return context;
};
